import { getPlayer, getTeam } from "../../utils.js";
import GameFactEventDto from "../GameFactEventDto.js";

export class FaultDto extends GameFactEventDto {

    constructor(event){
        super(event);
        this.tab = event.tab ??"FAUTE"
        this.detail = {
            ...this.detail,
            title : event.detail?.title || "FAUTE",
            player: event.detail?.player,
            reason: event.detail?.reason,
          };
    }

    get player() {
        return this.detail.player;
    }
    set player(value) {
        this.detail.player = value;
    }

    get reason() {
        return this.detail.reason;
    }
    set reason(value) {
        this.detail.reason = value;
    }

    initTimerPeriod(match){
        super.initTimerPeriod(match)
    }

    updateDetail(key, value, match) {
        super.updateDetail(key, value)
        
        // On peut modifier le text et le title
        if(this.isAutomaticCommentary && ["isAutomaticCommentary", "team", "player", "reason"].includes(key)){
            let commentaire = "Faute"

            const faultPlayer = getPlayer(this.player, match)
            const opponentPlayer = getPlayer(this.opponent, match)
            const team = getTeam(this.team, match)

            if(this.player){
                if(faultPlayer){
                    commentaire += ' de '+ faultPlayer.lastname
                }
            }else if(team){
                commentaire += ' de '+ team.name
            }

            if(this.opponent){
                if(opponentPlayer){
                    commentaire += ' sur '+ opponentPlayer.lastname
                }
            }

            commentaire += "! "

            if(this.reason){
                switch(this.reason){
                    case 'horsjeu':
                        commentaire+='Raison : Hors jeux.'
                    break
                    case 'maulecroule':
                        commentaire+='Raison : Maul écroulé.'
                    break
                    case 'meleeecroule':
                        commentaire+='Raison : Mêlée écroulée.'
                    break
                    case 'plaquageanticipe':
                        commentaire+='Raison : Plaquage anticipé.'
                    break
                    case 'tenirleballon':
                        commentaire+='Raison : Tenir le ballon.'
                    break
                    case 'jeudeloyal':
                        commentaire+='Raison : Jeu déloyal.'
                    break
                }
            }

            this.text = commentaire
        }
    }
}